export default __webpack_public_path__ + "static/media/outgoing-call.525b5542.svg";